export const reservationsIs = {
  hero: {
    title: 'Bóka borð',
    subtitle: 'Bókaðu borðið þitt og upplifðu ekta napólska matargerð',
  },
  form: {
    guestInfoTitle: 'Upplýsingar um gesti',
    reservationDetailsTitle: 'Upplýsingar um bókun',
    name: 'Fullt nafn',
    email: 'Netfang',
    phone: 'Símanúmer (valfrjálst)',
    guests: 'Fjöldi gesta',
    date: 'Dagsetning',
    time: 'Tími',
    note: 'Bæta við athugasemd (valfrjálst)',
    button: 'Bóka borð',
    submitting: 'Bóka...',
    confirmation:
      'Bókunarbeiðnin þín hefur verið send. Við munum staðfesta bókunina þína fljótlega með tölvupósti!',
    defaultNote: 'Þú munt fá staðfestingarpóst þegar bókunin þín hefur verið staðfest.',
    placeholders: {
      name: 'Nafnið þitt',
      email: 'Netfangið þitt',
      phone: 'Símanúmerið þitt',
      note: 'Sérstakar óskir, fæðuþarfir eða upplýsingar um hátíðarhöld...',
    },
    timeOptions: {
      select: 'Veldu tíma',
    },
    guestOptions: {
      guest: 'Gestur',
      guests: 'Gestir',
      nineplus: '9+ Gestir',
    },
    success:
      'Takk fyrir bókunarbeiðnina þína! Við munum staðfesta bókunina þína fljótlega með tölvupósti.',
    submitting: 'Bóka...',
  },
  sidebar: {
    hours: {
      title: 'Opnunartími',
      weekdays: 'Mánudagur - Laugardagur: 12:00 - 22:00',
      sunday: 'Sunnudagur: 17:00 - 22:00',
    },
    groupBookings: {
      title: 'Hópbókanir',
      description:
        'Fyrir hópa með 9 eða fleiri, vinsamlegast hafðu beint samband við okkur til að skipuleggja bókunina þína.',
    },
    policy: {
      title: 'Bókunarstefna',
      items: [
        'Bókanir eru geymdar í 15 mínútur eftir bókunartíma',
        'Fyrir afbókanir, vinsamlegast láttu okkur vita að minnsta kosti 2 klukkustundum fyrr',
        'Sérstakar óskir eru háðar framboði',
        'Hástólar fyrir börn eru í boði samkvæmt beiðni',
      ],
    },
  },
};
